import Swiper from 'swiper';
import { Navigation, Thumbs, Zoom } from 'swiper/modules';

// product-form-new.js
export default (Alpine) => {
    Alpine.data("productForm", () => ({
        options:[],
        currentVariant: null,
		sellingPlan: '',
		deliveryOptions: false,
		quantity: 1,
		purchaseOption: 'Subscribe & Save',
		unitPriceCents: 0,
		sku: '',
		shopifyPaymentTermsEl: null,
		jsLoaded: false,
		isMerch: false,
		is_preorder: false,
		preorder_message: '',
		productId: null,
		bundleEnabled: false,
		unitPricing: false,
		stackBoxes: 1,
		stackTiers: [],
		stackParentId: null,
		stackParentVariantId: null,
		stackParentTitle: '',
		dynamicBoxId: null,
		combinedListingSelect: null,
		buttonText: 'CHOOSE FREQUENCY',
		dropdownStates: [],
		sellingPlanName: 'Select Frequency',
		buyButton: null,
		showWidget: false,
		freeShippingThreshold: 9000,
		awayFromFreeShipping: 0,
		productsToReachFreeShipping: 0,
		cartHasSubscription: false,
		formattedAwayFromFreeShipping: '',
		upsellVariant: {},
		upsellEnabled: false,
		gallerySwiper: null,
		gallerySwiperThumbs: null,
		zoomActive: false,
		upsellVisible: false,

		// Flavor Select Dropdown
		showSizeChart: false,
		_handleSizeChartClick: null,

        init() {
			this.jsLoaded = true;

            this.variants = Object.values(window.variantObject);
			this.productId = this.variants[0].product_id

			if (document.querySelector('#accelerated-checkout-button')) {
			    this.buyButton = document.querySelector('#accelerated-checkout-button');
				this.refactorAdditionalCheckoutButtons()
			}

			this.combinedListingSelect = this.$el.querySelector('select.combined.option-select');

			if (window.location.search.includes('variant=')) {
				const variantId = window.location.search.split('variant=')[1];
				this.currentVariant = this.variants.find(variant => String(variant.id) === String(variantId));
			} else {
				this.currentVariant = this.variants.find(variant => variant.selected === true);
			}

			if (this.$el.querySelector('#product-options')) {
				this.isMerch = this.$el.querySelector('#product-options').dataset.merch === 'true' ? true : false;
			}

			const stack = this.$el.querySelector('[data-stack]');

			if (stack) {
				this.bundleEnabled = stack.hasAttribute('data-bundle-and-save');
				this.unitPricing = stack.hasAttribute('data-bundle-units');
				this.stackParentId = Number(stack.dataset.stackParentId) || null;
				this.stackParentVariantId = Number(stack.dataset.stackParentVariantId) || null;
				this.stackParentTitle = stack.dataset.stackParentTitle || '';
				this.stackTiers = (stack.dataset.stackTiers || '')
					.split(',')
					.map((tier) => Number(tier.trim()) || 0);


				const checkedStack = stack.querySelector('input[name="stack"]:checked');

				if (checkedStack) {
					this.stackBoxes = Number(checkedStack.value) || this.stackBoxes;

					if (this.unitPricing) {
						this.quantity = this.stackBoxes;
						// The qty input registers its listener on init, so let it mount first.
						this.$nextTick(() => this.setQuantity(this.quantity));
					}
				}


				if (this.stackParentId) {
					this.fetchDynamicBox();
				}
			}

			if (!this.currentVariant) {
				this.currentVariant = this.variants[0];
			}


			this.is_preorder = this.currentVariant.is_preorder;
			this.preorder_message = this.currentVariant.preorder_message;

			const purchaseOptions = this.$el.querySelectorAll('[data-purchase-option]');
			if (purchaseOptions) {
				this.buttonText = window.variantHasSellingPlan ? 'CHOOSE FREQUENCY' : 'ADD TO CART';
				purchaseOptions.forEach(option => {
					const input = option.querySelector('input[type="radio"]');
					input.addEventListener('change', this.purchaseOptionChange.bind(this));
				});
			} else {
				this.buttonText = this.is_preorder ? 'PREORDER' : 'ADD TO CART';
			}

			const frequencyOptions = this.$el.querySelector('.frequencyOptions');

			if (frequencyOptions) {
				frequencyOptions.addEventListener('change', this.frequencyChange.bind(this));
			}

			document.addEventListener('add-to-cart', this.addToCart.bind(this));
			document.addEventListener('quantity-change', this.quantityChange.bind(this));

			const checkedPurchase = this.$el.querySelector('[data-purchase-option] input[type="radio"]:checked');
			const deliveryOptions = this.$el.querySelector('.deliveryOptions');
			if (checkedPurchase?.value) {
			  this.purchaseOption = checkedPurchase.value;
			} else {
			  this.purchaseOption = (this.currentVariant?.selling_plan_allocations > 0 && !this.isMerch)
				? 'Subscribe & Save'
				: 'One-time Purchase';
			}

			if (this.purchaseOption === 'Subscribe & Save') {
				const freqSelector = this.$el.querySelector('.frequency-select');
				this.sellingPlan = freqSelector?.dataset?.value || this.sellingPlan || '';
				this.sellingPlanName = freqSelector?.dataset?.name || this.sellingPlanName || 'Select Frequency';
				this.applyDefaultSellingPlan();
				deliveryOptions?.classList.add('open');
			} else {
				this.sellingPlan = '';
				this.sellingPlanName = 'Select Frequency';
				deliveryOptions?.classList.remove('open');
			}

			this.setVariantDetails(this.currentVariant);

			const dropdowns = this.$el.querySelectorAll('.dropdown');

			for (let i = 0; i < dropdowns.length; i++) {
				this.dropdownStates.push(false);
			}

			this.options = this.currentVariant.options;

			this.setAvailability();

			setTimeout(() => {
				this.updateShippingGameWidget();
			}, 1000);


			if (this.$el.querySelector('.upsell-product')) {
				this.upsellVariant = {
					variant_id: this.$el.querySelector('.upsell-product .option-radio:checked').dataset.variantId,
					available: this.$el.querySelector('.upsell-product .option-radio:checked').dataset.available,
				}
			}

			document.addEventListener('rebuy:cart.change', this.updateShippingGameWidget.bind(this));
        },

		formatMoney(price) {
			return (price / 100).toLocaleString('en-US', {
				style: 'currency',
				currency: 'USD',
			});
		},

		get bundleBoxes() {
			if (!this.bundleEnabled) return 1;

			return this.unitPricing ? this.units : this.stackBoxes;
		},

		get units() {
			return Math.max(1, Number(this.quantity) || 1);
		},

		activeTier() {
			return Math.min(this.units, this.stackTiers.length);
		},

		setQuantity(units) {
			document.dispatchEvent(new CustomEvent('quantity-change', {
				bubbles: true,
				detail: { quantity: units },
			}));
		},

		
		tierTotal(unitCents) {
			const boxes = this.bundleBoxes;
			const unitDiscount = Math.floor((unitCents * this.stackDiscount(boxes)) / 100);

			return (unitCents - unitDiscount) * boxes;
		},

		get totalOriginalPrice() {
			return this.formatMoney(this.unitPriceCents * this.bundleBoxes);
		},

		get totalOtpPrice() {
			return this.formatMoney(this.tierTotal(this.unitPriceCents));
		},

		get totalSubPrice() {
			return this.formatMoney(this.tierTotal(this.unitSubPriceCents));
		},

		stackDiscount(boxes) {
			// Top tier is open-ended — 3+ all price at the 3-box rate.
			return this.stackTiers[Math.min(boxes, this.stackTiers.length) - 1] || 0;
		},

		stackUnitPrice() {

			if (this.purchaseOption === 'Subscribe & Save') {
				return this.unitSubPriceCents;
			}

			return this.originalUnitPrice();
		},

		
		get unitSubPriceCents() {
			const byPlan = this.currentVariant?.selling_plan_prices || {};
			const forPlan = byPlan[String(this.sellingPlan)];

			if (forPlan !== undefined) {
				return Number(forPlan) || 0;
			}

			return Number(this.currentVariant?.selling_plan_price_cents) || this.unitPriceCents;
		},


		originalUnitPrice() {
			return Number(this.currentVariant?.price_cents) || 0;
		},

		stackSubtotal(boxes) {
			return this.originalUnitPrice() * boxes;
		},

		stackCompareAt(boxes) {
			return this.formatMoney(this.stackSubtotal(boxes));
		},

		stackTotal(boxes) {
			// Skio discounts each unit and floors to the cent before multiplying
			// out, so taking the percentage off the line total would read a cent
			// or two under what the cart actually charges.
			const unit = this.stackUnitPrice();
			const unitDiscount = Math.floor((unit * this.stackDiscount(boxes)) / 100);

			return (unit - unitDiscount) * boxes;
		},

		stackPrice(boxes) {
			return this.formatMoney(this.stackTotal(boxes));
		},

		
		stackIsDiscounted(boxes) {
			return this.stackTotal(boxes) < this.stackSubtotal(boxes);
		},

		async fetchDynamicBox() {
			try {
				const res = await fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', Accept: '*/*' },
					body: JSON.stringify({ productPlatformId: this.stackParentId }),
				});
				const data = await res.json();
				const box = data?.DynamicBox;

				this.dynamicBoxId = box?.boxId || null;

			
				if (box?.percentDiscountTier) {
					this.stackTiers = this.stackTiers.map((fallback, index) => {
						const fromBox = box.percentDiscountTier[String(index + 1)];

						return fromBox === undefined ? fallback : Number(fromBox);
					});
				}
			} catch (error) {
				console.error('Dynamic Box Error:', error);
			}
		},

		async getBundleIndex() {
			const res = await fetch('/cart.js');
			const cartData = await res.json();

			const indices = cartData.items
				.map((item) => Number(item.properties?._dynamicBoxIndex))
				.filter((value) => !isNaN(value));

			return (indices.length > 0 ? Math.max(...indices) : -1) + 1;
		},

		generateUniqueHash(length = 32) {
			const randomPart = Array.from(crypto.getRandomValues(new Uint8Array(length)))
				.map((b) => b.toString(16).padStart(2, '0'))
				.join('');

			return `${Date.now().toString(16)}${randomPart}`;
		},

		async stackItems(childQty, bundles = 1) {
			const bundleIndex = await this.getBundleIndex();
			const sellingPlan = this.sellingPlan ? Number(this.sellingPlan) : null;
			const base = {
				_attribution: 'Skio Dynamic Product Bundle',
				_attribution_stack: 'Skio Stack',
				_dynamicBoxId: this.dynamicBoxId,
				_bundleSellingPlanId: sellingPlan,
				_stackParentId: this.stackParentId,
				_stackParentTitle: this.stackParentTitle,
				_is_stack: true,
				_internal_id: this.dynamicBoxId,
				// Tells the cart widget to step the child line instead of every line.
				...(this.unitPricing ? { _unit_bundle: true } : {}),
			};

			// Each bundle is a box of its own to Skio, so it gets its own index and
			// session id rather than riding along on a higher line quantity.
			return Array.from({ length: bundles }, (_, offset) => {
				const shared = { ...base, _bundle_session_id: this.generateUniqueHash() };

				return [
					{
						id: this.currentVariant.id,
						quantity: childQty,
						selling_plan: sellingPlan,
						properties: { ...shared, _dynamicBoxIndex: bundleIndex + offset, _is_stack_child: true },
					},
					{
						id: this.stackParentVariantId,
						quantity: 1,
						selling_plan: sellingPlan,
						properties: { ...shared, _is_stack_parent: true },
					},
				];
			}).flat();
		},

		animateShippingGame(e) {
			this.$refs.shippingGameArrow.classList.remove('visible');
			setTimeout(() => {
				this.$refs.shippingGameArrow.classList.add('visible');
			}, 500);
		},

		openGallery(e) {
			e.preventDefault();
			e.stopPropagation();
		  
			this.$refs.gallery.showModal();
		  
			if (this.gallerySwiper) {
			  this.gallerySwiper.destroy(true, true);
			}

			if (this.gallerySwiperThumbs) {
				this.gallerySwiperThumbs.destroy(true, true);
			}

			this.gallerySwiperThumbs = new Swiper(this.$refs.gallerySwiperThumbs, {
				modules: [Navigation],
				slidesPerView: 4,
				spaceBetween: 8,
				navigation: {
					nextEl: this.$refs.gallerySwiperThumbs.querySelector('.swiper-button-next'),
					prevEl: this.$refs.gallerySwiperThumbs.querySelector('.swiper-button-prev'),
				}
			});
		  
			this.gallerySwiper = new Swiper(this.$refs.gallerySwiper, {
			  modules: [Navigation, Thumbs, Zoom],
			  thumbs: {
				swiper: this.gallerySwiperThumbs,
			  },
			  zoom: {
				maxRatio: 2,
				minRatio: 1,
				panOnlyInZoom: true,
			  },
			  navigation: {
				nextEl: this.$refs.gallerySwiper.querySelector('.swiper-button-next'),
				prevEl: this.$refs.gallerySwiper.querySelector('.swiper-button-prev'),
			  },
			});
		  
			this.gallerySwiper.slideTo(0);

			this.setupZoomEventListeners();
		},

		setupZoomEventListeners() {
			this.gallerySwiper.el.addEventListener(
			  'pointerdown',
			  (ev) => {
			  if (ev.target.closest('.zoom-icon')) {
				  ev.preventDefault();
				  ev.stopPropagation();
			  }
			  },
			  true
		  );
		  
		  this.gallerySwiper.el.addEventListener('click', (ev) => {
			  const btn = ev.target.closest('.zoom-icon');
			  if (!btn) return;
			  ev.preventDefault();
			  ev.stopPropagation();
		  
			  const scale = this.gallerySwiper.zoom?.scale ?? 1;
			  this.zoomActive = !this.zoomActive;
		  
			  if (btn.classList.contains('zoom-out')) {
			  this.gallerySwiper.zoom.out();
			  return;
			  }
		  
			  // zoom-in icon => always center
			  if (scale > 1) this.gallerySwiper.zoom.out();
			  else this.zoomToCenter(this.swiper, 5);
		  }, true);
			  
		  // Merch zoom handling - Excl zoom icons
		  this.gallerySwiper.on('click', (swiper, e) => {
			  const target = e.target;
			  if (target?.closest?.('.swiper-pagination')) return;
			  if (target?.closest?.('.zoom-icon')) return;
			
			  const scale = swiper.zoom?.scale ?? 1;
			  this.zoomActive = !this.zoomActive;
	
			  if (scale > 1) swiper.zoom.out();
			  else swiper.zoom.in(e, 5);
		  });
		},
	
		zoomToCenter(swiper, ratio = 5) {
		  const zoomEl =
			swiper.slides[swiper.activeIndex]?.querySelector('.swiper-zoom-container') ||
			swiper.el.querySelector('.swiper-slide-active .swiper-zoom-container');
		  if (!zoomEl) return;
		
		  const zoomTarget = zoomEl.querySelector('.swiper-zoom-target') || zoomEl;
		
		  requestAnimationFrame(() => {
			const r = zoomEl.getBoundingClientRect();
			const cx = r.left + r.width / 2;
			const cy = r.top + r.height / 2;
		
			const evt = {
			  clientX: cx,
			  clientY: cy,
			  pageX: cx + window.scrollX,
			  pageY: cy + window.scrollY,
			  target: zoomTarget,
			  originalEvent: {
				clientX: cx,
				clientY: cy,
				pageX: cx + window.scrollX,
				pageY: cy + window.scrollY,
				target: zoomTarget,
			  },
			};
		
			swiper.zoom.in(evt, ratio);
		  });
		},
		  
		closeGallery(e) {
			e.preventDefault();
			e.stopPropagation();
		  
			this.$refs.gallery.close();
		  
			if (this.gallerySwiper) {
			  this.gallerySwiper.destroy(true, true);
			  this.gallerySwiper = null;
			}

			if (this.gallerySwiperThumbs) {
				this.gallerySwiperThumbs.destroy(true, true);
				this.gallerySwiperThumbs = null;
			}

			this.zoomActive = false;

		},

		refactorAdditionalCheckoutButtons() {
			if (!this.buyButton) {
				return;
			}

			if (typeof window?.Shopify?.PaymentButton?.init === 'function') {
				window.Shopify.PaymentButton.init();
			}
		
			const walletId = 'wallet';
			const walletSingleId = 'wallet-single';
		
			const walletElemAttr = document.getElementById(walletId)?.innerText;
			const walletElemSingleAttr = document.getElementById(walletSingleId)?.innerText;
			if (!walletElemAttr && !walletElemSingleAttr) {
				return;
			}
		
			const walletElem = walletElemAttr?.split('wallet-configs="')[1]?.split('"')[0];
			const walletElemSingle = walletElemSingleAttr?.split('recommended="')[1]?.split('"')[0];
			const walletElemClear = walletElem?.replace(/&quot;/g, '"');
			const jsonWallet = JSON.parse(walletElemClear);
		
			let filteredWallet = jsonWallet?.find((item) => item.name === 'apple_pay');
		
			if (!filteredWallet) {
				filteredWallet = jsonWallet?.find((item) => item.name === 'paypal');
			}
		
			if (!filteredWallet) {
				filteredWallet = jsonWallet?.find((item) => item.name === 'shop_pay');
			}
		
			const newWalletStr = JSON.stringify(filteredWallet)?.replaceAll('"', '&quot;');
			const newWallStr = document.getElementById(walletSingleId)?.innerText?.replace(walletElemSingle, newWalletStr);
		
			const checkoutButtonPlaceholder = document.querySelector('[data-checkout-button-placeholder]');
			if (checkoutButtonPlaceholder) {
				checkoutButtonPlaceholder.remove();
			}
		
			document.getElementById(walletSingleId)?.insertAdjacentHTML('beforebegin', newWallStr);
		
			const consent = document.getElementById('shopify-buyer-consent');
			if (consent) {
				consent.remove();
			}  
		},

		toggle(e, index) {
			if (this.dropdownStates[index]) {
				setTimeout(() => {
					return this.close(e.target, index)
				}, 100);
			}

			this.$refs.button.focus()

			this.dropdownStates[index] = true
		},

		close(focusAfter, index) {
			if (! this.dropdownStates[index]) return

			setTimeout(() => {
				this.dropdownStates[index] = false
			}, 100);

			focusAfter && focusAfter.focus()
		},

		onKeyDown(event, index) {
			const options = Array.from(this.$refs.panel.querySelectorAll('[role="option"]'));
			const current = event.currentTarget;
			const optionIndex = options.indexOf(current);
			const next = options[optionIndex + 1] || options[0]; // wrap to first
			next.focus();
		  },
		  
		  onKeyUp(event) {
			const options = Array.from(this.$refs.panel.querySelectorAll('[role="option"]'));
			const current = event.currentTarget;
			const optionIndex = options.indexOf(current);
			const prev = options[optionIndex - 1] || options[options.length - 1]; // wrap to last
			prev.focus();
		  },

		  openAndFocusOption(event, index) {
			if (!this.dropdownStates[index]) {
			  this.dropdownStates[index] = true;
			}
		  
			this.$nextTick(() => {
			  const selected =
				this.$refs.panel.querySelector('[aria-selected="true"]') ||
				this.$refs.panel.querySelector('[role="option"]');
		  
			  if (selected) {
				selected.focus();
			  }
			});
		  },

		  openSizeChart() {
			const dialog = document.getElementById('size-chart');

			if (!dialog) return;
		  
			dialog.showModal();
		  },
		  
		  closeSizeChart(e) {
			const dialog = document.getElementById('size-chart');
			if (!dialog) return;
		  
			dialog.close();
		  },
		  
		  

        onVariantChange(e, index) {
			let options = [];
			const optionIndex = index - 1;

			if (this.isMerch) {
				options = Array.from(e.target.closest('#product-options').querySelectorAll('input[type="radio"]:checked'));
				this.options = options.map((option) => option.value);
			} else {
				const next = [...this.options];
				next[optionIndex] = e.currentTarget.dataset.value;
				this.options = next;
			}

			this.getCurrentVariant(e, index);

			console.log('variant changed', this.currentVariant);

			const variantChanged = new CustomEvent('variant-changed', {
				detail: { variant: this.currentVariant },
				bubbles: true,
			})


			const subEl = document.querySelector('[data-subscription-option]');
			const otpEl = document.querySelector('[data-one-time-option]');


			// If variant has selling plan allocations, show the subscription option, otherwise hide
			if (this.currentVariant.selling_plan_allocations > 0 && !this.isMerch) {
				if (subEl) {
					subEl.classList.remove('hidden');
					subEl.querySelector('input[type="radio"]').checked = true;
				}
				this.purchaseOption = 'Subscribe & Save';
				const frequencyOptions = document.querySelector('.frequencyOptions');
				if (frequencyOptions) {
					frequencyOptions.value = '';
				}

				this.sellingPlan = ''
				this.sellingPlanName = 'Select Frequency';
				this.applyDefaultSellingPlan();
			} else {
				this.purchaseOption = 'One-time Purchase';
				this.sellingPlan = '';
				this.sellingPlanName = 'Select Frequency';
				
				if (subEl) {
					subEl.classList.add('hidden');
				}
				if (otpEl) {
					otpEl.querySelector('input[type="radio"]').checked = true;
				}

			}


			this.setVariantDetails(this.currentVariant);
			this.setAvailability()

			this.toggleDeliveryOptions();
			this.toggleOtpLastChance();

			// If URL includes query parameters, update query parameters for the current variant
			if (window.location.search.includes('variant=')) {
				const url = new URL(window.location.href);
				url.searchParams.set('variant', this.currentVariant.id);
				window.history.pushState({}, '', url.toString());
			}

			// Dispatch event to tell the product gallery to update the variant images
			// product-gallery-v2.js
			document.dispatchEvent(variantChanged)

			this.updateShippingGameWidget();

			this.close(e.target, index);
        },

		setVariantDetails(currentVariant) {

			const variant = Object.values(this.variants).find(v =>
				String(v.id) === String(currentVariant.id)
			  );	
			  
			const sku = variant.sku;
			const option1 = variant.option1.replace("'", "");
			const option2 = variant.option2;

			this.sku = sku;
			this.unitPriceCents = Number(variant.price_cents) || 0;
			this.option1 = option1;
			this.option2 = option2;

			this.isPreorder = variant.is_preorder;
			this.preorderMessage = variant.preorder_message;

			const skuElement = document.querySelector('[data-sku]');
			if (skuElement) {
				skuElement.textContent = this.sku;
			}

			// Sticky ATC Price
			const priceAtcElement = document.querySelector('[data-atc-price]');
			if (priceAtcElement) {
				priceAtcElement.textContent = this.purchaseOption === 'Subscribe & Save' ? String(this.totalSubPrice) : String(this.totalOtpPrice);
			}

			// Merch Product Price
			const merchPriceElement = document.querySelector('[data-price-merch]');
			if (merchPriceElement) {
				merchPriceElement.textContent = variant.price;
			}

			// Merch Product Compare Price
			const merchComparePriceElement = document.querySelector('[data-compare-price-merch]');
			if (merchComparePriceElement) {
				merchComparePriceElement.textContent = variant.compare_at_price;
			}

			// Shopify Payment Terms
			this.shopifyPaymentTermsEl = document.querySelector('shopify-payment-terms');

			if (this.shopifyPaymentTermsEl) {
				this.shopifyPaymentTermsEl.setAttribute('variant-id', this.currentVariant.id);
			}

			// Select Accessible Label
			const selectLabel = document.querySelectorAll('.select-label:not(product-recommendations .select-label)');
			selectLabel.forEach((label) => {
			    const selectDropdown = label.closest('div').querySelector('.select-select');
				const attrName = selectDropdown?.getAttribute('name');
				if (attrName === 'select-option1') {
                    label.setAttribute('for', this.option1);
					selectDropdown.setAttribute('id', this.option1);
                }
				if (attrName === 'select-option2') {
                    label.setAttribute('for', this.option2);
					selectDropdown.setAttribute('id', this.option2);
                }
			});
		},

		rebuildOptions(el) {

			let allOptions = {
				"option1": [],
				"option2": [],
				"option3": [],
			};

			this.variants.forEach(variant => {
				variant.options.forEach((option, index) => {
					if (!allOptions[`option${index + 1}`].includes(option)) {
						allOptions[`option${index + 1}`].push(option);
					}
				});
			});

			let availableOptions = {
				option1: [],
				option2: [],
				option3: [],
			}

			availableOptions.option1 = allOptions.option1
			availableOptions.option2 = allOptions.option2.filter(option => this.variants.some(variant => variant.option1 === this.currentVariant.option1 && variant.option2 === option));
			availableOptions.option3 = allOptions.option3.filter(option => this.variants.some(variant => variant.option1 === this.currentVariant.option1 && variant.option2 === this.currentVariant.option2 && variant.option3 === option));

			const optionContainer = el.querySelectorAll('[option-container]')
		
			optionContainer.forEach(container => {

				const optionSelect = container.querySelector('select.option-select');
				const optionCount = container.querySelector('[data-option-count]');
				const optionIndex = optionSelect.name.split('select-option')[1];

				if (optionCount) {
					optionCount.textContent = availableOptions[`option${optionIndex}`].length;
				}
				optionSelect.innerHTML = '';
				if (optionSelect.hasAttribute('data-flavor')) {
					optionSelect.setAttribute('data-flavor', this.currentVariant.option1);
				}
				availableOptions[`option${optionIndex}`].forEach(option => {
					const optionOption = document.createElement('option');
					optionOption.value = option;
					optionOption.text = option;
					optionSelect.add(optionOption);
					if (option === this.currentVariant[`option${optionIndex}`]) {
						optionSelect.value = option;
					}
				});

				this.rebuildVariantsDropdown(container, availableOptions[`option${optionIndex}`], optionIndex);
			});
		},

		rebuildVariantsDropdown(container, availableOptions, optionIndex) {
			const customSelectDropdown = container.querySelector('[x-ref="panel"]');
			const optionSelect = container.querySelector('select.option-select');
			const isFlavor = optionSelect.hasAttribute('data-flavor');

			customSelectDropdown.innerHTML = '';

				availableOptions.forEach((option, index) => {
					const matchingVariant = this.variants.find((variant) => {
					  // current option must match this row
					  if (variant.options[optionIndex - 1] !== option) return false;
				
					  // all prior options must match currentVariant
					  for (let i = 0; i < optionIndex - 1; i++) {
						if (variant.options[i] !== this.currentVariant.options[i]) return false;
					  }
				
					  return true;
					});
				
					if (!matchingVariant) return;
				
					const isCurrentVariant =
					  Number(matchingVariant.id) === Number(this.currentVariant.id);

					  let optionHTML = `
					  <div
						  role="option"
						  tabindex="-1"
						  data-index="${optionIndex}"
						  @keydown.arrow-up.prevent.stop="onKeyUp($event)"
						  @keydown.arrow-down.prevent.stop="onKeyDown($event)"
						  :aria-selected="${isCurrentVariant}"
						  @click="onVariantChange($event, ${optionIndex})"
						  data-value="${option}" data-variant-id="${matchingVariant.id}"
						  class="bg-white h-[52px] flex items-center justify-start gap-2.5 pl-3 pr-5 py-1.5 w-full transition-all duration-300 hover:bg-[#f5f5f5] relative"
						  >
						 ${isFlavor ? `
							  <span class="variant-flavor-icon pointer-events-none"
								  data-flavor="${option}">
								  <img src="${matchingVariant.flavor_image}" alt="${option}" width="45" height="45">
							  </span>
						  ` : ''}
						  <span class="font-bebasNeue pointer-events-none text-left">${option}</span>
						  <span 
						  data-is-current-variant="${isCurrentVariant}"
						  class="
						  ${isCurrentVariant ? '' : 'hidden'}
						  absolute right-4 top-1/2 -translate-y-1/2 h-4 w-4 p-1 text-white bg-black rounded-full flex items-center justify-center" 
						  >
							  <svg class="icon icon-checkmark w-4 h-4 color-foreground-{{ settings.accent_icons }}" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" fill="none">
							  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z" fill="currentColor"/>
						  </svg>
						  </span>
							<div class="divider mx-5 h-[1px] bg-[rgb(227,227,227,1)] absolute bottom-0 left-0 right-0 pointer-events-none"></div>
					  </div>
			  `;

			  customSelectDropdown.innerHTML += optionHTML;
			});
		},

		rebuildOptionsMerch(el) {
			let allOptions = {
			  option1: [],
			  option2: [],
			  option3: [],
			};
		  
			this.variants.forEach(variant => {
			  variant.options.forEach((option, index) => {
				const key = `option${index + 1}`;
				if (!allOptions[key].includes(option)) {
				  allOptions[key].push(option);
				}
			  });
			});
		  
			let availableOptions = {
			  option1: [],
			  option2: [],
			  option3: [],
			};
		  
			availableOptions.option1 = allOptions.option1;
			availableOptions.option2 = allOptions.option2.filter(option =>
			  this.variants.some(variant =>
				variant.option1 === this.currentVariant.option1 &&
				variant.option2 === option
			  )
			);
			availableOptions.option3 = allOptions.option3.filter(option =>
			  this.variants.some(variant =>
				variant.option1 === this.currentVariant.option1 &&
				variant.option2 === this.currentVariant.option2 &&
				variant.option3 === option
			  )
			);
		  
			const optionContainer = el.querySelectorAll('[option-container]');
		  
			// helper to normalize variant.available
			const isVariantAvailable = (variant) => {
			  const av = variant.available;
			  if (typeof av === 'boolean') return av;
			  if (typeof av === 'string') return av.toLowerCase() === 'true';
			  return !!av;
			};
		  
			optionContainer.forEach(container => {
			  const optionWrapper = container.querySelector('.option-wrapper');
			  const optionIndex = container.dataset.optionIndex;
			  const isColor = container.hasAttribute('data-color');
		  
			  optionWrapper.innerHTML = '';
		  
			  let optionInputsNew = [];
		  
			  availableOptions[`option${optionIndex}`].forEach(optionValue => {
				const idx = Number(optionIndex);
		  
				const optionAvailable = this.variants.some(variant => {
				  if (!isVariantAvailable(variant)) return false;
		  
				  if (variant[`option${idx}`] !== optionValue) return false;
		  
				  if (idx === 1) {
					return true;
				  }
		  
				  if (idx === 2) {
					const currentOpt1 = this.currentVariant.option1;
					if (currentOpt1 && variant.option1 !== currentOpt1) return false;
					return true;
				  }
		  
				  const currentOpt1 = this.currentVariant.option1;
				  const currentOpt2 = this.currentVariant.option2;
				  if (currentOpt1 && variant.option1 !== currentOpt1) return false;
				  if (currentOpt2 && variant.option2 !== currentOpt2) return false;
				  return true;
				});
		  
				const isCurrent = optionValue === this.currentVariant[`option${optionIndex}`];
				const soldOut = !optionAvailable;
				const disabledAttr = soldOut ? 'disabled' : '';
		  
				let optionInputNew = '';
				let color = window.colorPattern[optionValue];
		  
				if (isColor) {
				 const soldOutClass = soldOut ? 'sold-out sold-out-color diagonal-strike pointer-events-none' : '';

				  optionInputNew = `
					<fieldset class="relative h-12 w-12">
                      <legend class="visually-hidden">${optionValue}</legend>
					  <input
						@change="onVariantChange($event)"
						id="option-${optionIndex}-${optionValue}"
						type="radio"
						name="option${optionIndex}"
						value="${optionValue}"
						data-option-value="${optionValue}"
						data-value="${optionValue}"
						data-option-index="${optionIndex}"
						class="merch color appearance-none h-0 w-0 absolute top-0 left-0 opacity-0"
						${isCurrent ? 'checked' : ''}
						${disabledAttr}
					  />
					  <label
						for="option-${optionIndex}-${optionValue}"
						class="${soldOutClass} font-bebasNeue text-sm !opacity-100 p-5 z-2 border border-[#C3C3C3] h-full w-full flex items-center justify-center cursor-pointer ${isCurrent ? 'border-4 border-black' : ''}"
					  >
						<span class="absolute h-9 w-9 -z-1" style="
						${color.includes('www' || 'http') ? `background-image: url(${color});` : `background-color: ${color};`}"></span>
					  </label>
					</fieldset>`;
				} else {
				
				 const soldOutClass = soldOut ? 'sold-out pointer-events-none sold-out-merch' : '';

				  optionInputNew = `
					<fieldset class="relative h-12">
					  <legend class="visually-hidden">${optionValue}</legend>
					  <input
						@change="onVariantChange($event)"
						id="option-${optionIndex}-${optionValue}"
						type="radio"
						name="option${optionIndex}"
						value="${optionValue}"
						data-option-value="${optionValue}"
						data-value="${optionValue}"
						data-option-index="${optionIndex}"
						class="merch appearance-none h-0 w-0 absolute top-0 left-0 opacity-0"
						${isCurrent ? 'checked' : ''}
						${disabledAttr}
					  />
					  <label
						for="option-${optionIndex}-${optionValue}"
						class="${soldOutClass} font-bebasNeue text-sm !opacity-100 p-5 z-2 border border-[#C3C3C3] h-full w-full flex items-center justify-center cursor-pointer ${isCurrent ? 'border-4 border-black' : ''}"
					  >
						${optionValue}
						${soldOut ? `<svg
                        class="absolute inset-0 w-full h-full pointer-events-none"
                        viewBox="0 0 100 100"
                        preserveAspectRatio="none"
                        >
                        <line
                        x1="0" y1="0" x2="100" y2="100"
                        stroke="#CCC"
                        stroke-width="2"
                        />
                        </svg>
						` : ''}
					  </label>
					</fieldset>`;
				}
		  
				optionInputsNew.push(optionInputNew);
			  });
		  
			  optionWrapper.innerHTML = optionInputsNew.join('');
			});
		},

		changeCombinedListing(e) {
			window.location.href = e.target.value
		},
		  		  
        getCurrentVariant(e, index) {
			const wanted = this.options.map(v => String(v).trim());

			let variant = null;

			const exact = this.variants.find(v =>
				wanted.every((val, i) => String(v.options[i]).trim() === val)
			);

			if (exact) variant = exact;

			// if no variant found, use first option and apply default 2nd and 3rd options
			if (!variant) {
				variant = this.variants.find((variant) => {
					return variant.option1 === this.options[0];
				});
			}

            this.currentVariant = variant;

			if (this.isMerch) {
				this.rebuildOptionsMerch(e.target.closest('#product-options'))
			} else {
				this.rebuildOptions(e.target.closest('#product-options'))
			}
        },

		setAvailability() {
			const available = this.currentVariant.available;
			const button = document.querySelector('#buy-button button');

			if (this.currentVariant.is_preorder) {
				button.disabled = false;
				this.buttonText = 'PREORDER';
				this.buyButton?.classList?.remove('opacity-50');
				this.buyButton?.classList?.remove('pointer-events-none');
			} else if (!available) {
				button.disabled = true;
				this.buttonText = 'SOLD OUT';
				this.buyButton?.classList.add('opacity-50');
				this.buyButton?.classList.add('pointer-events-none');
			} else if (this.currentVariant.selling_plan_allocations > 0) {
				button.disabled = this.purchaseOption === 'Subscribe & Save' && (this.sellingPlan === '' || this.sellingPlan === null) ? true : false;
				this.buttonText = this.purchaseOption === 'Subscribe & Save' && (this.sellingPlan === '' || this.sellingPlan === null) ? 'SELECT FREQUENCY' : 'ADD TO CART';
				const visible = this.purchaseOption === 'Subscribe & Save' && (this.sellingPlan === '' || this.sellingPlan === null) ? false : true;
				this.buyButton?.classList?.toggle('opacity-60', !visible);
				this.buyButton?.classList?.toggle('pointer-events-none', !visible);
			} else {
				button.disabled = false;
				this.buttonText = 'ADD TO CART';
				this.buyButton?.classList?.remove('opacity-50');
				this.buyButton?.classList?.remove('pointer-events-none');
			}
		},

		purchaseOptionChange(e) {
			const freqSelector = this.$el.querySelector('.frequency-select');

			if (e.target.value === 'Subscribe & Save') {
				this.sellingPlan = freqSelector.dataset.value;
				this.sellingPlanName = freqSelector.dataset.name;
				this.applyDefaultSellingPlan();
				this.purchaseOption = 'Subscribe & Save';
				this.showWidget = false;
			} else {
				this.sellingPlan = '';
				this.sellingPlanName = 'Select Frequency';
			
				this.purchaseOption = 'One-time Purchase';
				this.updateShippingGameWidget();
			}

			this.toggleDeliveryOptions();
			this.toggleOtpLastChance();
			this.setVariantDetails(this.currentVariant);
			this.setAvailability();
		},

		applyDefaultSellingPlan() {
			const id = this.currentVariant?.default_selling_plan;
			if (this.sellingPlan || !id) return;
			this.sellingPlan = id;
			this.sellingPlanName = this.currentVariant.default_selling_plan_name;
		},

		toggleDeliveryOptions() {
			const deliveryOptionsEl = this.$el.querySelector('.deliveryOptions');
			if (!deliveryOptionsEl) return;
			const isSub = this.purchaseOption === 'Subscribe & Save';
			deliveryOptionsEl.classList.toggle('open', isSub);
		},

		toggleOtpLastChance() {
			const otpLastChance = document.querySelector('.otpLastChance');
			if (!otpLastChance) return;
			const isOtp = this.purchaseOption === 'One-time Purchase';
			otpLastChance.classList.toggle('show', isOtp && this.currentVariant.selling_plan_allocations > 1);
		},

		frequencyChange(e) {
			this.sellingPlan = e.target.dataset.value;
			this.sellingPlanName = e.target.dataset.name;
			this.setAvailability();
			this.close(e.target, e.target.dataset.index);
		},

		async updateShippingGameWidget() {

			const shippingGameWidget = this.$refs.shippingGameWidget;

			if (!shippingGameWidget) return;
			
			let cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());

			if (!cart) return;

			const selectedVariantPrice = (Number(this.currentVariant.price.replace('$', '')) * 100) || 0;
			const cartTotal = cart?.total_price || 0;
			const bundleProductId = 10165916139840;
			const teeProductId = 10165234860352;
			const cartHasBundle = cart?.items?.some(item => item.product_id === bundleProductId);
			const cartHasTee = cart?.items?.some(item => item.product_id === teeProductId);
			const hasBundleAndTee = cartHasBundle && cartHasTee;

			this.cartHasSubscription = cart?.items?.some(item => item.selling_plan_allocation != null) || false;
			this.awayFromFreeShipping = this.freeShippingThreshold - cartTotal;
			this.productsToReachFreeShipping = Math.ceil(this.awayFromFreeShipping / selectedVariantPrice);
			this.formattedAwayFromFreeShipping = this.formatMoney(this.awayFromFreeShipping);

			if (hasBundleAndTee) {
				this.showWidget = false;
			} else if (this.productsToReachFreeShipping === 1 && this.purchaseOption === 'One-time Purchase' && !this.cartHasSubscription) {
				this.showWidget = true;
			} else {
				this.showWidget = false;
			}
		},

		selectUpsellOption(e) {
			e.preventDefault();
			e.stopPropagation();
			
			this.upsellVariant = {
				variant_id: e.target.dataset.variantId,
				available: e.target.dataset.available,
			};
			this.upsellEnabled = e.target.dataset.available === 'true';
		},

		quantityChange(e) {
			this.quantity = e.target.value ? Number(e.target.value) : e.detail?.quantity;
		},

        async addToCart() {
            const sideCart = document.querySelector('side-cart');

			let preorderProperties = {};

			if (this.currentVariant.is_preorder) {
				preorderProperties = { properties: { preorder: this.currentVariant.preorder_message } };
			}

			let upsellItem = null;

			if (this.upsellEnabled && this.upsellVariant.variant_id) {
				upsellItem = {
					id: this.upsellVariant.variant_id,
					quantity: this.quantity,
				}
			}

		
			const useStack = this.stackParentId
				&& this.stackParentVariantId
				&& this.dynamicBoxId
				&& (this.unitPricing || this.stackBoxes > 1);

			// Unit pricing puts the whole order in one bundle; the older tiers add
			// one bundle per qty step, so they still multiply.
			const quantity = this.bundleEnabled
				? (this.unitPricing ? this.units : this.stackBoxes * this.units)
				: this.quantity;

			const bundles = this.unitPricing ? 1 : this.units;
			const childQty = this.unitPricing ? this.units : this.stackBoxes;

			let items = useStack
				? [...(await this.stackItems(childQty, bundles)), upsellItem]
				: [
					// null, not '' — matching stackItems(), so a one-time line never
					// carries an empty selling_plan through to /cart/add.js.
					{
						id: this.currentVariant.id,
						selling_plan: this.sellingPlan ? Number(this.sellingPlan) : null,
						quantity,
						...preorderProperties,
					},
					upsellItem,
				];
			
			items = items.filter(Boolean);

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    items: items,
                }),
            })
            .then(response => response.json())
            .then(data => {
                Rebuy.SmartCart.show()
				this.updateShippingGameWidget();

				document.dispatchEvent(new CustomEvent('quantity-change', {
					bubbles: true,
					detail: { quantity: 1 },
				}));
            })
            .catch(error => {
                console.error('Error:', error);
            });
        },	
    }));
  };